import type { StringUnion } from '@gonfalon/types/StringUnion';

export const FALLTHROUGH_RULE_ID = 'fallthrough';

export type ReleasePhaseConfigurationKey = StringUnion<typeof FALLTHROUGH_RULE_ID>;
